import GuideContent from "@/containers/Content/components/Guide/GuideContent";
import GuideHead from "@/containers/Content/components/Guide/GuideHead";
import { useViewpostTopObserver } from "@/hooks/useViewpostTopObserver";
import { Box, Stack } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  customEvent,
  getCdnImageSrc,
  HStack,
  Image,
  responsive,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";

export default function PrepareFirst() {
  const router = useRouter();
  const { viewportTopRef } = useViewpostTopObserver();
  const feed = {
    path: "2",
    date: "25-04-28",
    title: "장례 비용을 아끼는\n 가장 확실한 방법",
    description: "",
    imgSrc: "direct/content/prepare/2-background.png",
    keyword: "상조, 장례, 100원 상조",
    contents: [
      {
        type: "h2",
        resource: "모든 비용이 오르는데, 장례는 예외일까요?",
      },
      {
        type: "p",
        resource:
          "지금 미리 알아본 장례 비용, 실제로 서비스를 이용하게 될 10년~20년 후에도 그대로일까요? 유감스럽게도 장례식장 사용료는 물론 봉안당, 화장 비용 모두 매년 오르고 있기에 시간이 흐를수록 훨씬 더 많은 금액이 들 수 밖에 없습니다.",
      },
      {
        type: "p",
        resource: "<b>하지만 상조 비용은 다릅니다.</b>",
      },
      {
        type: "p",
        resource:
          "<b>상조를 미리 가입해두면 지금 가격 그대로, 미래의 장례를 준비할 수 있습니다.</b> 그리고 이 계약으로 <b>가입 당시 가격이 평생 유지</b>됩니다. \n\n📌 지금 가입하면 10년 후, 20년 후에도 같은 비용으로 장례를 치를 수 있습니다.",
      },
      {
        type: "p",
        resource: "",
      },
      {
        type: "h2",
        resource: "하지만 상조는 잘 몰라서 부담스러워요.",
      },
      {
        type: "p",
        resource:
          "장례가 낯선만큼이나 상조에 대해서도 잘 모르는 분들이 많습니다. 모르기때문에 더욱 꺼려지기도 하죠. 그래서 상조는 뭐하는 회사인지, 이용하면 무엇이 다른건지 여기서 차근차근 알려드리려고 합니다. 먼저 상조란 장례를 순조롭게 진행하기 위해 다음과 같은 3가지를 제공하는 서비스를 말합니다.",
      },
      {
        type: "h3",
        resource: "1. 장례 전문가 인력",
      },
      {
        type: "p",
        resource:
          "입관부터 발인까지 유족을 안내하는 <b>장례지도사</b>와, 조문객 응대 및 음식 준비를 돕는 <b>접객 도우미</b>가 있습니다.",
      },
      {
        type: "h3",
        resource: "2. 장례 용품",
      },
      {
        type: "p",
        resource:
          "장례를 치를 때 필요한 용품으로 수의, 관, 유골함, 염습 도구 등이 있습니다.",
      },
      {
        type: "h3",
        resource: "3. 차량 서비스",
      },
      {
        type: "p",
        resource:
          "고인을 가장 먼저 수습해 옮기기 위한 앰뷸런스 배차부터 발인 시 고인을 운구하는 리무진, 유가족분들이 이용하는 장의버스가 있습니다.",
      },
      {
        type: "p",
        resource: "",
      },
      {
        type: "h2",
        resource: "Q. 장례식장에서 자체적으로 진행하면 되는 거 아닌가요?",
      },

      {
        type: "p",
        resource: "👤 “장례식장에서도 다 해준다던데요?”",
      },
      {
        type: "p",
        resource:
          "병원이나 장례식장에서 “상조 없이도 저희가 다 도와드릴게요”라고 하기도 하는데요. 하지만 실제로 장례식장 중심으로 장례를 치를 경우엔 다음과 같은 어려움이 있습니다.",
      },
      {
        type: "h3",
        resource: "1. 장례지도사의 지속적인 안내가 어려운 구조입니다.",
      },
      {
        type: "p",
        resource:
          "장례식장 소속 장례지도사는 하루에도 여러 건의 장례를 동시에 맡는 경우가 많습니다. 이로 인해 한 분 한 분의 장례에 충분히 집중하기 어렵고, 입관부터 발인까지 유족에게 감정적으로 세심한 안내가 부족해지기 쉽습니다.",
      },
      {
        type: "h3",
        resource: "2. 음식과 용품이 과하게 소비될 수 있습니다.",
      },
      {
        type: "p",
        resource:
          "장례식장에서는 음식과 용품이 주요 수익원입니다. 그래서 조문 인원보다 많은 음식을 권하거나, 남기더라도 일단 많이 주문하게 유도하는 경우가 있습니다. 이 과정에서 낭비가 발생하더라도 유족 입장에선 조절하기 어렵습니다.",
      },
      {
        type: "p",
        resource: "",
      },

      {
        type: "h2",
        resource: "🔎 그래서 어떤 상조를 선택해야 할까요?",
      },

      {
        type: "p",
        resource:
          "앞에서 살펴본 바와 같이, 선불제 상조를 미리 준비하는 데엔 분명히 이점이 있습니다. 하지만 시중엔 불투명한 계약, 위약금, 강매형 상품도 적지 않습니다. 이 이유로 상조를 꺼리는 분들이 있기도 하고요. 그래서 다음 콘텐츠에서는 후회 없는 상조를 고르는 법, 절대 속지 말아야 할 항목들을 알려드릴게요.",
      },
    ],
  };
  return (
    <VStack width="100%" alignItems="center">
      <div ref={viewportTopRef}></div>
      <GuideHead
        title={feed.title}
        date={"2025년 04월 28일"}
        imgSrc={feed.imgSrc}
      />

      <Stack
        maxWidth={`720px`}
        width="100%"
        css={responsive({
          gap: { base: "28px", md: "40px" },
          padding: { base: "0 0 160px", lg: "60px 0px 160px" },
        })}
      >
        <GuideContent contents={feed.contents} isFeed />

        <VStack alignItems="center" margin="20px 0">
          <Box
            fontSize="16px"
            color={colors.gray600}
            backgroundColor={colors.gray50}
            width="fit-content"
            borderRadius="6px"
            padding="10px 20px"
            fontWeight="500"
            cursor="pointer"
            onClick={() => {
              customEvent({
                newGtm: { path: "content", trigger_and_target: "share" },
              });
              navigator.clipboard.writeText(window.location.href);
              alert("링크가 복사되었습니다.");
            }}
          >
            이 컨텐츠 공유하기
          </Box>
        </VStack>

        <VStack gap="30px" css={responsive({ padding: "0 10px" })}>
          <HStack
            alignItems="center"
            gap="10px"
            justifyContent="space-between"
            border={`1px solid ${colors.gray200}`}
            borderRadius="10px"
            css={{ cursor: "pointer" }}
            onClick={() => {
              customEvent({
                newGtm: { path: "content", trigger_and_target: "next_content" },
              });
              router.push("/content/feeds/prepare/3/");
            }}
          >
            <Box width="150px" borderRadius="10px 0 0 10px" overflow="hidden">
              <Image
                src={getCdnImageSrc("direct/content/prepare/3-icon.png")}
                alt="이전편"
              />
            </Box>
            <HStack
              justifyContent="space-between"
              width="100%"
              alignItems="center"
              padding="20px 20px 20px 10px"
            >
              <Box>
                <Box className="gray500">다음편 바로보기</Box>
                <Box className="subtitle_18_sb">
                  03. 좋은 상조는 어떻게 골라야 할까요?
                </Box>
              </Box>
              <ColorIcon
                name="arrow_right_small"
                color={colors.gray400}
                size={16}
              />
            </HStack>
          </HStack>

          <VStack
            css={{
              borderRadius: "10px",
              border: `1px solid ${colors.gray200}`,
            }}
          >
            <Box
              padding="23px 20px"
              color={colors.gray600}
              backgroundColor={colors.gray50}
              className="subtitle_18_b"
            >
              시리즈 목록
            </Box>
            <HStack
              padding="24px 0px"
              margin="0 20px"
              gap="10px"
              className="body_16_r"
              css={{
                borderBottom: `1px solid ${colors.gray100}`,
                cursor: "pointer",
              }}
              onClick={() => {
                customEvent({
                  newGtm: { path: "content", trigger_and_target: "prepare_1" },
                });
                router.push("/content/feeds/prepare/1/");
              }}
            >
              <Box>01</Box>
              <Box>갑자기 오는 장례, 준비가 없으면 후회만 남습니다</Box>
            </HStack>
            <HStack
              padding="24px 0px"
              margin="0 20px"
              gap="10px"
              className="subtitle_16_sb orange650"
              css={{
                borderBottom: `1px solid ${colors.gray100}`,
                cursor: "pointer",
              }}
              onClick={() => {
                customEvent({
                  newGtm: { path: "content", trigger_and_target: "prepare_2" },
                });
                router.push("/content/feeds/prepare/2/");
              }}
            >
              <Box>02</Box>
              <Box>장례 비용 아끼는 가장 확실한 방법</Box>
            </HStack>
            <HStack
              padding="24px 0px"
              margin="0 20px"
              gap="10px"
              className="body_16_r"
              css={{
                borderBottom: `1px solid ${colors.gray100}`,
                cursor: "pointer",
              }}
              onClick={() => {
                customEvent({
                  newGtm: { path: "content", trigger_and_target: "prepare_3" },
                });
                router.push("/content/feeds/prepare/3/");
              }}
            >
              <Box>03</Box>
              <Box>좋은 상조는 어떻게 골라야 할까요?</Box>
            </HStack>
          </VStack>
        </VStack>
      </Stack>
    </VStack>
  );
}
